svg {
  object-fit: contain;
  shape-rendering: geometricprecision;
  max-height: var(--size);
  max-width: var(--size);
  height: 100%;
  width: 100%;
  display: inline-block;
}
